import { render } from "./DirectorySwitcher.vue?vue&type=template&id=c16eaebc"
import script from "./DirectorySwitcher.vue?vue&type=script&lang=js"
export * from "./DirectorySwitcher.vue?vue&type=script&lang=js"

import "./DirectorySwitcher.vue?vue&type=style&index=0&id=c16eaebc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__